<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiSend } from "@mdi/js";
export default {
  name: "MdiSend",
  data() {
    return {
      svgPath: mdiSend,
    };
  },
};
</script>
